<div class="card">
  <div class="service">
    @if (port(); as _port) {
      <service-title-block
        [isAccessible]="showVisual()"
        [healthStatus]="healthStatus()"
        [service]="_port"
        [tags]="tags()"
        [title]="customerDescription()"
      />
    }

    <div class="service__flex-table">
      <div class="service__flex-table-row">
        <div class="service__flex-table-col">
          <div class="service__flex-table-title">{{ "ServiceElement.Owner" | translate }}</div>
          <div class="service__flex-table-subtitle">{{ portOwner() }}</div>
        </div>
        <div class="service__flex-table-col">
          <div class="service__flex-table-title">{{ "Services.Fulfilment.Lightpath.Location" | translate }}</div>
          <div class="service__flex-table-subtitle">{{ city() }} ({{ street() }} {{ number() }})</div>
        </div>
      </div>
      <div class="service__flex-table-row">
        <div class="service__flex-table-col">
          @if (portId(); as _portId) {
            <div class="service__flex-table-title">{{ "ServiceElement.PortID" | translate }}</div>
            <div class="service__flex-table-subtitle"><service-id [subscriptionId]="_portId"></service-id></div>
          }
        </div>
        <div class="service__flex-table-col">
          <div class="service__flex-table-title">{{ "Subscription.VLANID" | translate }}</div>
          <div class="service__flex-table-subtitle">
            <span class="port__title">
              @if (showVlanrange()) {
                {{ vlanrange() }}
              } @else {
                {{ "Subscription.UntaggedPort" | translate }}
              }
            </span>
          </div>
        </div>
      </div>
      @if (serviceTag()) {
        <div class="service__flex-table-row">
          <div class="service__flex-table-col">
            <div class="service__flex-table-title">S-TAG</div>
            <div class="service__flex-table-subtitle">{{ serviceTag() }}</div>
          </div>
          <div class="service__flex-table-col">
            <div class="service__flex-table-title"></div>
            <div class="service__flex-table-subtitle"></div>
          </div>
        </div>
      }
    </div>
    <port-visualiser [subscription]="port()" [available]="showVisual()" (selected)="navigateToService($event)" />
  </div>
</div>
